import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';

const calculateCartTotals = (cartItems) => {
    let total = 0;

    // cartItems.forEach(({ price, quantity, fullModifiers }) => {
    //     const modifiersTotal = fullModifiers?.reduce((sum, mod) => sum + mod.price, 0) || 0;
    //     total += price * quantity + modifiersTotal;
    // });
    cartItems.forEach(item => {
        const baseProductPrice = item.price;
        const modifiersPricePerItem = item.fullModifiers?.reduce((sum, mod) => sum + mod.price, 0) || 0;
        total += (baseProductPrice + modifiersPricePerItem) * item.quantity;
    });

    const vat = +(total * 0.15).toFixed(2);
    const subTotal = +(total - vat).toFixed(2);

    return { total, vat, subTotal };
};

const getModifierIds = (selectedModifiers) => {
    return Object.values(selectedModifiers)
        .flat()
        .map(m => m.id)
        .sort((a, b) => a - b);
};

const initialState = {
    cartItems: [],
    cartTotals: { total: 0, vat: 0, subTotal: 0 },
    merchantId: null,
    branchId: null,
    orderType: null,
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addProductInCart: (state, action) => {
            const { product, qty, note, modifiers } = action.payload;
            const modifierIds = getModifierIds(modifiers || {});

            const existingCartItem = state.cartItems.find(item =>
                item.id === product.id && isEqual(item.modifierIds, modifierIds)
            );

            if (existingCartItem) {
                existingCartItem.quantity = qty;
                existingCartItem.note = note;
                // Update product details if they have changed
                Object.assign(existingCartItem, product, {
                    fullModifiers: Object.values(modifiers || {}).flat(),
                    modifierIds,
                });
            } else {
                const newCartItem = {
                    ...product,
                    cartItemId: `${product.id}-${modifierIds.join('-')}-${note || ''}-${Date.now()}`,
                    quantity: qty,
                    fullModifiers: Object.values(modifiers || {}).flat(),
                    modifierIds: modifierIds,
                    note: note || '',
                };
                state.cartItems.push(newCartItem);
            }
            state.cartTotals = calculateCartTotals(state.cartItems);
        },
        updateProductQtyInCart: (state, action) => {
            // const { lineIndex, actionType } = action.payload;
            // const itemIndex = state.cartItems.findIndex(p => p.id === lineIndex);
            const { cartItemId, actionType } = action.payload;
            const itemIndex = state.cartItems.findIndex(p => p.cartItemId === cartItemId);

            if (itemIndex > -1) {
                if (actionType === 'delete' || (actionType === 'dec' && state.cartItems[itemIndex].quantity <= 1)) {
                    state.cartItems.splice(itemIndex, 1);
                } else if (actionType === 'inc') {
                    state.cartItems[itemIndex].quantity += 1;
                } else if (actionType === 'dec') {
                    state.cartItems[itemIndex].quantity -= 1;
                }
            }
            state.cartTotals = calculateCartTotals(state.cartItems);
        },
        clearCartProducts: (state) => {
            state.cartItems = [];
            state.cartTotals = { total: 0, vat: 0, subTotal: 0 };
            state.merchantId = null;
            state.branchId = null;
            state.orderType = null;
        },
        setOrderMetaData: (state, action) => {
            state.branchId = action.payload.branchId;
            state.orderType = action.payload.orderType;
        },
        setMerchant: (state, action) => {
            state.merchantId = action.payload.merchantId;
        },
    },
});

export const {
    addProductInCart,
    updateProductQtyInCart,
    clearCartProducts,
    setOrderMetaData,
    setMerchant,
} = cartSlice.actions;

export default cartSlice.reducer;
